import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  title: string;
}>;

export const CodeSnippetCard = ({ title, children }: Props) => {
  return (
    <Card data-role="code-snippet">
      <CardHeader title={title} />
      <CardContent>
        <Box
          component="div"
          tabIndex={0}
          role="presentation"
          sx={{
            p: 2,
            backgroundColor: 'jsonViewer.background',
            whiteSpace: 'pre-wrap',
            fontFamily: 'monospace !important',
            fontSize: '1rem',
            overflowX: 'scroll',
          }}
        >
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};
